import React from "react";
import PropTypes from "prop-types"
import EventPublisher from "../../utils/EventPublisher";
import UIInteractionEvents from "../../constants/events/UIInteractionEvents";
import $ from "jquery";
import ImageUploaderView from "./ImageUploaderView";


class AdvertisementCreateView extends React.Component {

    static propTypes = {
        isSaving: PropTypes.bool.isRequired,
        showingImageSlideIndex: PropTypes.number.isRequired,
        title: PropTypes.object.isRequired,
        description: PropTypes.object.isRequired,
        imageNames: PropTypes.arrayOf(PropTypes.string).isRequired,
        uploadPercentage: PropTypes.number.isRequired
     };

    componentDidMount() {
        $('[data-toggle="tooltip"]').tooltip();
    }

    handleTitleChanged = (event) => {
        EventPublisher.publish(
            UIInteractionEvents.ADVERTISEMENT_CREATE_TITLE_CHANGED,
            {
                title: event.target.value,
                isValid: event.target.checkValidity()
            });
    };

    handleDescriptionChanged = (event) => {
        EventPublisher.publish(
            UIInteractionEvents.ADVERTISEMENT_CREATE_DESCRIPTION_CHANGED,
            {
                description: event.target.value,
                isValid: event.target.checkValidity()
            });
    };

    handleFormSubmit = (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (this.everythingIsValid()) {
            EventPublisher.publish(
                UIInteractionEvents.ADVERTISEMENT_CREATE_SAVE_SUBMITTED,
                {
                    title: this.props.title.currentValue,
                    description: this.props.description.currentValue,
                    imageNames: this.props.imageNames,
                }
            );
        }
    };

    handleCancelClicked = (event) => {
        event.preventDefault();
        event.stopPropagation();
        EventPublisher.publish(UIInteractionEvents.MY_ADVERTISEMENTS_BUTTON_CLICK, {});
    };

    everythingIsValid() {
        return this.props.title.isValid && this.props.description.isValid
    }

    generateClassNameWithValidityForFormFieldWithValidState(defaultClassName, formFieldWithValidityState) {
        if (formFieldWithValidityState.isTouched && formFieldWithValidityState.isValid) {
            return defaultClassName+" is-valid";
        } else if (formFieldWithValidityState.isTouched && !formFieldWithValidityState.isValid) {
            return defaultClassName+" is-invalid";
        }
        return defaultClassName;
    }

    render() {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header border-bottom-box">
                                <span className="align-middle">
                                    Create An Advertisement
                                </span>
                                <span className="ml-auto float-right">
                                    <button
                                        className="btn btn-primary btn-sm"
                                        onClick={this.handleCancelClicked}
                                    >
                                        Cancel
                                    </button>
                                </span>
                            </div>
                            <div className="card-body">
                                <div className="alert alert-primary">
                                    <h4 className="alert-heading">Want Help?</h4>
                                    Do you need help with design or printing?  Checkout our shop where you can:
                                    <ul>
                                        <li>Buy common products (ex. printed posters).</li>
                                        <li>Request design help.</li>
                                        <li>Request other printed products (ex. Car decals, Hats, Stickers).</li>
                                    </ul>
                                    <hr/>
                                    <div className="row w-100">
                                        <a href="https://cuvered.orderpromos.com/" target="_blank" rel="noreferrer" className="btn btn-primary m-auto">
                                            Visit the Design & Print Shop
                                        </a>
                                    </div>
                                </div>
                                <form noValidate>
                                    <div className="form-group">
                                        <label htmlFor="inputTitle">Title</label>
                                        <div className={this.generateClassNameWithValidityForFormFieldWithValidState("input-group flex-nowrap", this.props.title)}>
                                            <input
                                                type="text"
                                                className={this.generateClassNameWithValidityForFormFieldWithValidState("form-control", this.props.title)}
                                                id="inputTitle"
                                                placeholder="Dom's Garage Poster"
                                                onChange={this.handleTitleChanged}
                                                required={true}
                                                pattern=".{4,56}"
                                                disabled={this.props.isSaving}
                                            />
                                            <div className="input-group-append">
                                                <span
                                                    className="input-group-text"
                                                    id="addon-wrapping"
                                                    data-toggle="tooltip"
                                                    data-placement="bottom"
                                                    title="Required"
                                                >
                                                    <i className="fas fa-exclamation-circle text-warning"/>
                                                </span>
                                            </div>
                                        </div>
                                        <small id="titleHelpBlock" className="form-text text-muted">
                                            Briefly describe what this advertisement is. Consider adding information
                                            about the <strong className="text-cuvered-pink">medium</strong> (ex. Poster,
                                            Banner, Pamphlet, etc.) and the <strong className="text-cuvered-pink">domain
                                            </strong>( ex. Pizza Shop, Concert, etc.).
                                        </small>
                                        <div className="valid-feedback">
                                            Looks good!
                                        </div>
                                        <div className="invalid-feedback">
                                            "Please choose a title between 4 and 56 characters long."
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="inputDescription">Description</label>
                                        <div className={this.generateClassNameWithValidityForFormFieldWithValidState("input-group flex-nowrap", this.props.description)}>
                                            <textarea
                                                className={this.generateClassNameWithValidityForFormFieldWithValidState("form-control", this.props.description)}
                                                id="inputDescription"
                                                rows="10"
                                                onChange={this.handleDescriptionChanged}
                                                disabled={this.props.isSaving}
                                            />
                                            <div className="input-group-append">
                                                    <span
                                                        className="input-group-text"
                                                        id="addon-wrapping"
                                                    >
                                                        <i
                                                            className="fas fa-exclamation-circle text-warning"
                                                            data-toggle="tooltip"
                                                            data-placement="bottom"
                                                            title="Required"
                                                        />
                                                    </span>
                                            </div>
                                        </div>
                                        <small id="descriptionHelpBlock" className="form-text text-muted">
                                            What would you want the owner of a Space to know about your advertisement?
                                            Describe the <strong className="text-cuvered-pink">medium and sizing
                                            </strong> (ex. A 3x10 Poster on paper), the ideal
                                            <strong className="text-cuvered-pink">Demographics</strong> you would like
                                            to target (ex. Business Women in the Finance
                                            Industry), and the <strong className="text-cuvered-pink">Domain</strong>
                                            (ex. A Professional Training Seminar).
                                        </small>
                                        <div className="valid-feedback">
                                            Looks good!
                                        </div>
                                        <div className="invalid-feedback">
                                            "Please write a description."
                                        </div>
                                    </div>
                                    <ImageUploaderView
                                        isDisabled={this.props.isSaving}
                                        showingImageSlideIndex={this.props.showingImageSlideIndex}
                                        imageNames={this.props.imageNames}
                                        uploadPercentage={this.props.uploadPercentage}
                                        labelName={"Advertisement Images"}
                                    />
                                    <button
                                        type="submit"
                                        className={this.everythingIsValid() ? "btn btn-primary" : "btn btn-danger"}
                                        onClick={this.handleFormSubmit}
                                        disabled={this.props.isSaving || !this.everythingIsValid()}
                                    >
                                        {
                                            this.props.isSaving ?
                                                (
                                                    <span>
                                                        <span className="spinner-border spinner-border-sm mr-2"/>
                                                        Saving
                                                    </span>
                                                ) :
                                                "Submit"
                                        }
                                    </button>
                                    <span className="ml-2">
                                        {
                                            !this.everythingIsValid() ?
                                                (
                                                    <span className="alert alert-danger">
                                                        <i className="fas fa-exclamation-triangle mr-2"/>
                                                        Please fill out all required fields and correct any validation errors before proceeding.
                                                    </span>
                                                ):
                                                null
                                        }
                                    </span>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

export default AdvertisementCreateView;